import * as React from 'react';

function SvgOpenQuote(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 51 40" {...props}>
    <path
      fill="#FF3E45"
      d="M11.516 40q-5.209 0-8.363-3.574Q0 32.715 0 26.53q0-7.422 4.798-14.158Q9.597 5.636 19.331 0l4.25 4.948q-4.935 4.124-8.5 7.836-3.428 3.573-3.702 6.46l.548.412q.96-.825 3.017-.824 3.153 0 5.346 2.749t2.194 7.422q0 4.811-3.016 7.973Q16.452 40 11.516 40m27.42 0q-5.21 0-8.363-3.574-3.154-3.711-3.154-9.897 0-7.422 4.799-14.158Q37.016 5.636 46.75 0L51 4.948q-4.936 4.124-8.5 7.836-3.427 3.573-3.702 6.46l.549.412q.96-.825 3.016-.824 3.153 0 5.347 2.749 2.193 2.749 2.193 7.422 0 4.811-3.016 7.973Q43.872 40 38.935 40"
    />
  </svg>)
}
export default SvgOpenQuote;
